import React from 'react';
import { motion } from 'framer-motion';
import CompanyIntro from '../components/sections/about/CompanyIntro';
import Vision from '../components/sections/about/Vision';
import MultiSupport from '../components/sections/about/MultiSupport';
import Stats from '../components/sections/about/Stats';

const About = () => {
  return (
    <>
      <CompanyIntro />
      <Vision />
      <MultiSupport />
      <Stats />
    </>
  );
};

export default About;